import { Shield, Clock, Award, Users } from 'lucide-react';

const features = [
  {
    icon: Shield,
    title: 'Licensed & Insured',
    description: 'All technicians are fully certified and insured for your peace of mind.',
  },
  {
    icon: Clock,
    title: '2-Hour Arrival',
    description: 'We provide narrow arrival windows so you\'re not stuck waiting all day.',
  },
  {
    icon: Award,
    title: 'Brand Experts',
    description: 'Specialized training on Samsung, LG, Whirlpool, Bosch, and more.',
  },
  {
    icon: Users,
    title: 'Local Team',
    description: 'We live and work in the GTA neighborhoods we serve.',
  },
];

export const AboutSection = () => {
  return (
    <section className="py-20" style={{ background: '#1A2B4C' }} data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div>
            <span 
              className="inline-block px-4 py-2 rounded-full text-sm font-semibold mb-6"
              style={{ background: 'rgba(255, 107, 0, 0.2)', color: '#FF6B00' }}
            >
              About Us
            </span>
            <h2 
              className="text-3xl md:text-4xl font-bold text-white mb-6"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Your Local GTA Experts
            </h2>
            <p className="text-white/80 text-lg leading-relaxed mb-6">
              At Infinity Appliances Repair, we know that a broken fridge or a leaking washer isn't just an inconvenience—it's a disruption to your family's life. That's why we've dedicated ourselves to providing the fastest, most reliable appliance repair services across the Greater Toronto Area.
            </p>
            <p className="text-white/70 leading-relaxed mb-8">
              From the busy streets of Toronto and North York to the growing communities of Vaughan, Richmond Hill, and Markham, we are proud to be the first call for homeowners when an appliance fails. We aren't a massive, faceless corporation; we are local technicians who live and work in the same GTA neighborhoods we serve.
            </p>
            
            {/* Features Grid */}
            <div className="grid grid-cols-2 gap-6">
              {features.map((feature) => {
                const IconComponent = feature.icon;
                return (
                  <div 
                    key={feature.title} 
                    className="flex gap-3"
                    data-testid={`about-feature-${feature.title.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    <div 
                      className="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center"
                      style={{ background: 'rgba(255, 107, 0, 0.2)' }}
                    >
                      <IconComponent size={20} style={{ color: '#FF6B00' }} />
                    </div>
                    <div>
                      <h4 
                        className="font-semibold text-white mb-1"
                        style={{ fontFamily: 'Montserrat, sans-serif' }}
                      >
                        {feature.title}
                      </h4>
                      <p className="text-sm text-white/60">{feature.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Image/Stats */}
          <div className="relative">
            <div className="glass-card-dark rounded-2xl p-8 shadow-2xl">
              <div className="text-center mb-8">
                <h3 
                  className="text-2xl font-bold text-white mb-2"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  Why GTA Homeowners Choose Infinity
                </h3>
                <p className="text-white/60">Trusted by thousands of families</p>
              </div>
              
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center p-4 rounded-xl" style={{ background: 'rgba(255, 255, 255, 0.05)' }}>
                  <div className="text-4xl font-bold mb-2" style={{ color: '#FF6B00', fontFamily: 'Montserrat, sans-serif' }}>
                    4.9
                  </div>
                  <p className="text-white/70 text-sm">Google Rating</p>
                </div>
                <div className="text-center p-4 rounded-xl" style={{ background: 'rgba(255, 255, 255, 0.05)' }}>
                  <div className="text-4xl font-bold mb-2" style={{ color: '#FF6B00', fontFamily: 'Montserrat, sans-serif' }}>
                    2hr
                  </div>
                  <p className="text-white/70 text-sm">Arrival Window</p>
                </div>
                <div className="text-center p-4 rounded-xl" style={{ background: 'rgba(255, 255, 255, 0.05)' }}>
                  <div className="text-4xl font-bold mb-2" style={{ color: '#FF6B00', fontFamily: 'Montserrat, sans-serif' }}>
                    8+
                  </div>
                  <p className="text-white/70 text-sm">GTA Cities Served</p>
                </div>
                <div className="text-center p-4 rounded-xl" style={{ background: 'rgba(255, 255, 255, 0.05)' }}>
                  <div className="text-4xl font-bold mb-2" style={{ color: '#FF6B00', fontFamily: 'Montserrat, sans-serif' }}>
                    24/7
                  </div>
                  <p className="text-white/70 text-sm">Emergency Service</p>
                </div>
              </div>

              <p className="text-center text-white/50 text-sm mt-8 italic">
                "Treat every repair like it's for our own family."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
